import React from "react"

const RedSodaLoading = ({ ...props }) => (
  <div className="inset-0 flex items-center justify-center" {...props}>
    <span className="inline-block w-[32px] h-[32px]">
      <span className="relative block w-full h-[100%] transform rotate-45 animate-spin">
        <span className="absolute top-0 left-0 w-[12px] h-[12px] bg-[#CE2D41] rounded-full"></span>
        <span className="absolute top-0 right-0 w-[12px] h-[12px] bg-[#CE2D41] rounded-full"></span>
        <span className="absolute bottom-0 left-0 w-[12px] h-[12px] bg-[#CE2D41] rounded-full"></span>
        <span className="absolute bottom-0 right-0 w-[12px] h-[12px] bg-[#CE2D41] rounded-full"></span>
      </span>
    </span>
  </div>
)

export default RedSodaLoading
